import React, { useEffect } from 'react';
import './pip.style.scss';

const ProductErrorB2C = () => {

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('default-4xx.load-pip', {});
    }
  }, []);

  return (
    <div className="sui-my-12 sui-mx-auto sui-p-5 sui-text-danger sui-font-bold" data-testid="b2c-messaging">
      <p>The product you are trying to view is not currently available.</p><br />
      <p>If you have any questions,
        you can reach our web support team by email at
        customercare@homedepot.com or by phone at 1-800-430-3376
      </p>
    </div>
  );
};

ProductErrorB2C.displayName = 'ProductErrorB2C';

export { ProductErrorB2C };